import { useEffect, useState } from "react";

// Re-render every minute so "in progress", countdowns and progress stay true while the page is open.
export default function useNow(intervalMs = 60_000) {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);
  return now;
}
